export const PRODUCT_MODE = {
  STUDIO: 'studio',
  EDUCATORS: 'educators',
};

// The mode is kept on a cookie of the shared vbee domain rather than in this
// origin's storage, because the landing page is the side that decides where
// login lands and it cannot read storage across origins. One place to write it
// means the two sides can never disagree about which mode the browser is in.
export const PRODUCT_MODE_COOKIE_KEY = 'product-mode';

// A settled choice rather than a trace of what was opened last, which is what
// the ServiceSelect cookie beside it holds — so it outlives that fortnight by a
// long way.
export const PRODUCT_MODE_COOKIE_EXPIRED = 1000 * 60 * 60 * 24 * 365; // 1 year

// How the recent projects list is laid out. Kept here rather than beside the
// list, because the layout reducer holds the choice and needs its default.
export const RECENT_PROJECTS_VIEW = { LIST: 'list', GRID: 'grid' };

// A frame this far into a video usually shows real content, unlike an opening
// fade. The nearest keyframe is taken, so a short video lands on whatever it has.
export const THUMBNAIL_SECOND = 3;

// Signup survey answers that say the account belongs in Educators mode. Matched
// on the answer alone, whichever question asked it: the option carries the
// meaning, the question is only how the survey happens to be grouped today, and
// a regrouped survey would otherwise stop recognising answers that still say
// teacher.
//
// So only options specific enough to mean education belong here. Option keys are
// not unique across questions — all three reuse "other" — and a general one
// would match answers that mean nothing of the sort. "other" is also the one
// holding free text, which there is no matching anyway.
export const EDUCATORS_SIGNUP_ANSWERS = ['teacher', 'education'];
